<template>
  <v-container fluid class="py-0">
    <!-- Loader -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!--Dialog to Read Rdf File -->
    <v-dialog
      content-class="artDialog"
      v-model="pdfdialog"
      width="unset"
      scrollable
    >
      <GenericPDFReaderVue :selectedPdf="this.selectedPdf" @closedialog="closepdf" />
    </v-dialog>
    <!-- Disegno Delete Confirmation Dialog -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogElimina"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text">
            Questo elemento verrà eliminato definitivamente
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro? vuoi eliminare questa elemento?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="delSelectedItem">ANNULLA</v-btn>
          <v-btn color="green" dark @click="deldisegno">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Firma Disegno Dialog -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogFirma"
      width="400"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text">Firma Disegno</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Firmare il disegno selezionato?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialogFirma = false">ANNULLA</v-btn>
          <v-btn color="green" dark @click="signdrawing">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modal to Add Files or Images -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogAllegati"
      width="400"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">Allegati</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="dialogAllegati = false" small>
                <v-icon v-on="on" v-bind="attrs" color="error" depressed
                  >mdi-window-close</v-icon
                >
              </v-btn>
            </template>
            <span>Cancellare</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-file-input
            accept="*"
            @change="onFileChange(allegato)"
            style="display: inline-block; width: 400px"
            type="file"
            v-model="allegato"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Model to Add or Update Disegno -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialog"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">{{
            this.specifiche_sel == -1 ? "Aggiungi Disegno" : "Aggiorna Disegno"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <Button
            colore_icona="success"
            idForm="ARTICOLO_MODIFICA_DISEGNO"
            idOggetto="SALVA_DISEGNO_ARTICOLO"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva"
            v-on:buttonClick="slavaDesigno(item)"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeModal" small>
                <v-icon v-on="on" v-bind="attrs" color="error" depressed
                  >mdi-window-close</v-icon
                >
              </v-btn>
            </template>
            <span>Cancellare</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-row align="center" class="pa-0" justify="center">
            <v-col cols="6" md="3">
              <TextField
                idForm="DISEGNO"
                idOggetto="DISEGNO_COD_ALTERNATIVO"
                label_input="Codice Alternativo"
                palceholder_input="Codice Alt."
                :vmodel="specifiche_sel.cod_alternativo"
                v-on:changeText="
                  (val) => (specifiche_sel.cod_alternativo = val)
                "
              />
            </v-col>
            <v-col cols="6" md="2">
              <TextField
                idForm="DISEGNO"
                idOggetto="DISEGNO_REVISIONE_ARTICOLO"
                label_input="Revisione"
                palceholder_input="Revisione"
                :vmodel="specifiche_sel.revisione_articolo"
                v-on:changeText="
                  (val) => (specifiche_sel.revisione_articolo = val)
                "
                :min_input="0"
                type_input="number"
              />
            </v-col>
            <v-col cols="6" md="2">
              <TextField
                idForm="DISEGNO"
                idOggetto="DISEGNO_INDICE_MODIFICA"
                label_input="Indice"
                palceholder_input="Indice Modifica"
                :vmodel="specifiche_sel.indice_modifica"
                v-on:changeText="
                  (val) => (specifiche_sel.indice_modifica = val)
                "
              />
            </v-col>
            <v-col cols="6" md="2">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dum_format"
                    label="DUM"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="specifiche_sel.dum"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="mt-4" cols="6" md="1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="dialogAllegati = true"
                  >
                    <v-icon color="#1a80b6">mdi-paperclip</v-icon>
                  </v-btn>
                </template>
                <span>Nuovo Disegno</span>
              </v-tooltip>
            </v-col>
            <v-col class="mt-3" cols="6" md="1" v-if="disegno != ''">
              <!-- Card per le immagini -->

              <v-card
                v-if="!isPdf(disegno) && !isDxF(disegno)"
                class="d-flex justify-center"
              >
                <div v-viewer class="images clearfix d-flex align-items-center">
                  <img
                    id="immagine"
                    style="
                      height: 100% !important;
                      width: 100%;
                      display: block !important;
                    "
                    :src="disegno"
                    :lazy-src="disegno"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  />
                </div>
              </v-card>
              <!-- Card per i PDF -->
              <v-card
                @click="openPdfAppenaCaricato(disegno)"
                style="
                  height: 40px !important;
                  width: 80px !important;
                  margin-right: -10rem !important;
                "
                v-if="isPdf(disegno) && !isDxF(disegno)"
              >
                <div style="text-align: center">
                  <v-spacer></v-spacer>
                  <v-icon color="error" x-large> mdi-file-pdf-box </v-icon>
                </div>
              </v-card>

              <v-card
                @click="openDxf(disegno)"
                style="
                  height: 40px !important;
                  width: 80px !important;
                  margin-right: -10rem !important;
                "
                v-show="isDxF(disegno)"
              >
                <div style="text-align: center">
                  <v-spacer></v-spacer>
                  <v-icon color="error" x-large> mdi-file-cad-box </v-icon>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <form>
      <v-row>
        <v-col cols="7" md="7" sm="12">
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                style="width: 100%"
                class="mr-4"
                :elevation="hover ? 24 : 2"
              >
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">Disegno</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <Button
                    classe_bottone="mr-5"
                    colore_icona="primary"
                    idForm="ARTICOLO_DISEGNO"
                    idOggetto="CREA_DISEGNO_ARTICOLO"
                    mdi_icona="mdi-plus"
                    testo_tooltip="Aggiungi Disegno"
                    v-on:buttonClick="handleclick(null)"
                  />
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-row>
                  <v-col md="12">
                    <v-data-table
                      :loading="loading"
                      :items="items"
                      :headers="headers"
                    >
                      <v-progress-linear
                        v-show="progressBar"
                        slot="progress"
                        color="blue"
                        indeterminate
                      ></v-progress-linear>
                      <template v-slot:[`item.firma`]="{ item }">
                        <Button
                          colore_icona="blue"
                          idForm="ARTICOLO_DISEGNO"
                          idOggetto="FIRMA_DISEGNO_ARTICOLO"
                          mdi_icona="mdi-file-question-outline"
                          testo_tooltip="Firma Disegno"
                          v-on:buttonClick="signatureDisegno(item)"
                        />
                      </template>
                      <template v-slot:[`item.edit`]="{ item }">
                        <Button
                          classe_bottone="ml-n8"
                          colore_icona="primary"
                          idForm="ARTICOLO_DISEGNO"
                          idOggetto="MODIFICA_DISEGNO_ARTICOLO"
                          mdi_icona="mdi-pencil"
                          testo_tooltip="Aggiornare"
                          v-on:buttonClick="handleclick(item)"
                        />
                      </template>

                      <template v-slot:[`item.dum`]="{ item }">
                        {{ item.dum | formatDate }}
                      </template>
                      <template v-slot:[`item.disegno`]="{ item }">
                        <!-- Card per le immagini -->
                        <v-card
                          style="
                            height: 40px !important;
                            width: 80px !important;
                            margin-right: -10rem !important;
                          "
                          v-show="!isPdf(item.disegno) && !isDxF(item.disegno)"
                        >
                          <div v-viewer class="images clearfix">
                            <img
                              style="
                                height: 40px !important;
                                display: block !important;
                                width: 60px !important;
                                margin-right: -10rem !important;
                              "
                              :src="item.disegno"
                              :lazy-src="item.disegno"
                              aspect-ratio="1"
                              class="grey lighten-2"
                            />
                          </div>
                        </v-card>
                        <!-- Card per i PDF -->
                        <v-card
                          @click="openPdf(item)"
                          style="
                            height: 40px !important;
                            width: 80px !important;
                            margin-right: -10rem !important;
                          "
                          v-show="isPdf(item.disegno)"
                        >
                          <div style="text-align: center">
                            <v-spacer></v-spacer>
                            <v-icon color="error" x-large>
                              mdi-file-pdf-box
                            </v-icon>
                          </div>
                        </v-card>
                        <!-- Card per i dxf -->
                        <v-card
                          @click="openDxf(item.disegno)"
                          style="
                            height: 40px !important;
                            width: 80px !important;
                            margin-right: -10rem !important;
                          "
                          v-show="isDxF(item.disegno)"
                        >
                          <div style="text-align: center">
                            <v-spacer></v-spacer>
                            <v-icon color="error" x-large>
                              mdi-file-cad-box
                            </v-icon>
                          </div>
                        </v-card>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <Button
                          colore_icona="error"
                          idForm="ARTICOLO_DISEGNO"
                          idOggetto="ELIMINA_DISEGNO_ARTICOLO"
                          mdi_icona="mdi-window-close"
                          testo_tooltip="Cancellare"
                          v-on:buttonClick="disegnoToDel(item)"
                        />
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-hover>
        </v-col>
        <v-col cols="5" md="5" sm="12">
          <v-hover>
            <template v-slot="{ hover }">
              <v-card :elevation="hover ? 24 : 2">
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Specifiche Tecniche
                  </v-toolbar-title>
                  <v-btn class="ml-5" @click="dialog_info_pattern = true" icon>
                    <v-icon color="#FFFFFF">
                      mdi-information-variant-circle
                    </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-container
                  class="mx-1"
                  fluid
                  style="overflow-y: scroll; height: 100vh"
                >
                  <v-row>
                    <v-col class="py-0" cols="6">
                      <v-text-field label="Barcode" v-model="barcode" />
                    </v-col>
                    <v-col class="py-0" cols="6">
                      <v-autocomplete
                        v-model="id_report"
                        :items="items_report"
                        label="Report Standard"
                        required
                        item-text="cod_report"
                        item-value="id_label"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col class="py-0" cols="4">
                      <v-autocomplete
                        v-model="certificato_prodotto"
                        :items="certificato_prodotto_list"
                        placeholder="Certificato Prodotto"
                        required
                        item-text="des"
                        item-value="id_tabella"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col class="py-0" cols="4">
                      <v-text-field
                        label="Scadenza"
                        type="number"
                        v-model.number="scadenza"
                      >
                        <template v-slot:append>
                          <v-icon
                            @click="annullaScadenza"
                            color="error"
                            v-if="scadenza != null"
                          >
                            mdi-close
                          </v-icon>
                        </template> </v-text-field
                      >
                    </v-col>
                    <v-col class="py-0" cols="4">
                      <v-autocomplete
                        v-model="id_um_scadenza"
                        :items="items_scadenza"
                        placeholder="UM Scadenza"
                        required
                        item-text="des"
                        item-value="id_tabella"
                      >
                        <template v-slot:append>
                          <v-icon
                            @click.stop="annullaUMScadenza"
                            color="error"
                            v-if="id_um_scadenza != null"
                          >
                            mdi-close
                          </v-icon>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0" cols="4">
                      <TextField
                        idForm="DISEGNO"
                        idOggetto="SPECIFICHE_TIMBRO"
                        label_input="Codice Timbro"
                        palceholder_input="Codice Timbro"
                        :vmodel="data.timbro"
                        v-on:changeText="(val) => (data.timbro = val)"
                      />
                    </v-col>
                    <v-col class="py-0" cols="4">
                      <v-select
                        :items="items_tipi_lotto"
                        item-text="des"
                        item-value="val_int"
                        label="Tipo Prefisso Lotto"
                        v-model="cod_prefisso_lotto"
                      />
                    </v-col>
                    <v-col class="py-0" cols="4" v-if="cod_prefisso_lotto == 1">
                      <v-text-field
                        label="Prefisso Lotto"
                        v-model="prefisso_lotto"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0 d-flex align-center" cols="6">
                      <v-checkbox
                        v-model="data.gestione_lotto"
                        label="Gestione Lotti"
                        :false-value="0"
                        :true-value="1"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="py-0 d-flex align-center" cols="6">
                      <v-checkbox
                        v-model="prelievo_lotti_successivi"
                        label="Prelievo Lotti Successivi"
                        :false-value="0"
                        :true-value="1"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox
                        :false-value="0"
                        label="Gestione Seriale"
                        style="margin-top: -1rem"
                        :true-value="1"
                        v-model="data.gestione_seriale"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox
                        style="margin-top: -1rem"
                        label="Particolare Critico"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row class="mx-1">
                    <v-col cols="12">
                      <v-data-table
                        :items="itemsLotti.filter((e) => e.validita == 1)"
                        :headers="headersLotti"
                        dense
                      >
                        <template v-slot:[`item.id_tabella`]="{ item }">
                          {{
                            forniture?.filter(
                              (e) => e.id_tabella == item.id_tabella
                            )[0]?.des
                          }}
                        </template>
                        <template
                          v-slot:[`item.formato_codice_lotto`]="{ item }"
                        >
                          <v-text-field
                            v-model="item.formato_codice_lotto"
                            dense
                          />
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row class="mx-1">
                    <v-col cols="12">
                      <v-textarea
                        outlined
                        v-model="data.specifiche"
                        label="Specifiche"
                        placeholder="Specifiche"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </form>
    <v-dialog v-model="dxfDialog" width="800">
      <DxfViewerVue ref="viewer" :dxfUrl="dxfurl" />
    </v-dialog>

    <!-- Dialog di informazioni sul pattern -->
    <v-dialog v-model="dialog_info_pattern" width="unset">
      <v-card style="max-width: 800px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Schema Codice Lotto
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di cihusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_info_pattern = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="text-align: left; color: rgb(0, 0, 0); font-size: 18px">
            <ul>
              <li><b>{dy}</b>: numero del giorno nell'anno;</li>
              <li><b>{dd}</b>: numero del giorno nel mese;</li>
              <li><b>{ww}</b>: numero della settimana nell'anno;</li>
              <li><b>{mm}</b>: numero del mese dell'anno in 2 cifre;</li>
              <li>
                <b>{M}</b>: mese in lettere (gennaio = A, febbraio = B, ecc...),
              </li>
              <li><b>{yyyy}</b>: anno in 4 cifre;</li>
              <li><b>{yy}</b>: ultime due cifre dell'anno;</li>
              <li><b>{COD}</b>: codice della sottofamiglia dell'articolo;</li>
              <li><b>{nrX}</b>: numero progressivo formattato su X cifre;</li>
              <li>
                <b>{pd}</b>: forza l'azzeramento giornaliero del progressivo;
              </li>
              <li>
                <b>{pm}</b>: forza l'azzeramento mensile del progressivo
                (impostazione di default);
              </li>
              <li><b>{py}</b>: forza l'azzeramento annuale del progressivo;</li>
              <li><b>{TC}</b>: stampa il codice del tipo commessa;</li>
              <li>
                <b>{MP}</b>: stampa il codice lotto del componente principale
                usato per produrre.
              </li>
            </ul>
          </span>

          <div class="mt-5">
            <span style="color: rgb(0, 0, 0); font-size: 18px">
              Es. 1: L{yy}.{mm}-{nr5} = L23.09-00023<br />
              Nel formato non compaiono {pd} / {pm} / {py}: il progressivo si
              azzera mensilmente.
            </span>
          </div>

          <div class="mt-5">
            <span style="color: rgb(0, 0, 0); font-size: 18px">
              Es. 2: L{yy}.{mm}.{dd}-{nr5}{pd} = L23.09.01-00023<br />
              Nel formato compare {pd}: il progressivo si azzera ogni giorno.
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-container>
</template>
<script>
import TextField from "@/components/TOOLS/FormComponentPermissions/TextField.vue";
import Button from "@/components/TOOLS/FormComponentPermissions/Button.vue";
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import DxfViewerVue from "../../../../components/TOOLS/DxfViewer.vue";
import GenericPDFReaderVue from "../../../../components/TOOLS/GenericPDFReader.vue";

class Specifiche {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_disegno", default_val: -1 },
      { nome: "id_articolo", default_val: -1 },
      { nome: "cod_alternativo", default_val: "" },
      { nome: "indice_modifica", default_val: "" },
      { nome: "revisione_articolo", default_val: null },
      { nome: "disegno", default_val: "" },
      {
        nome: "dum",
        default_val: new Date().toISOString().substr(0, 10),
      },
      { nome: "validita", default_val: 1 },
      { nome: "tipo_disegno", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  props: ["data"],
  components: {
    Button,
    SnackbarQV,
    TextField,
    DxfViewerVue,
    GenericPDFReaderVue,
  },
  data() {
    return {
      // Variabili di supporto
      scadenza: null,
      id_um_scadenza: null,
      specifiche_sel: new Specifiche(),
      // overlay var
      selectedPdf: "",
      //Delete confirmation dialog
      deletedDisegno: {},
      selectedDisegno: "",
      item: "",
      id_report: null,
      cod_prefisso_lotto: null,
      barcode: null,
      prefisso_lotto: "",
      prelievo_lotti_successivi: null,

      // Modals
      dxfDialog: false,
      dialog_info_pattern: false,
      dialogElimina: false,
      overlay: false,
      pdfdialog: false,
      dialog: false,
      dialogAllegati: false,
      dialogFirma: false,
      menu1: false,
      progressBar: false,
      loading: false,

      // Array
      forniture: [],
      allegato: [],
      items: [],
      itemsLotti: [],
      items_tipi_lotto: new Array(),
      items_report: [],
      headersLotti: [
        {
          text: "Fornitura",
          value: "id_tabella",
        },
        {
          text: "Formato Codice",
          value: "formato_codice_lotto",
        },
      ],
      disegno: "",
      dxfurl: null,
      certificato_prodotto: "",
      certificato_prodotto_list: [],
      // Table header for Disegno
      headers: [
        {
          text: "",
          value: "firma",
          sortable: false,
        },
        {
          text: "",
          value: "edit",
          sortable: false,
        },
        {
          text: "Firma",
          value: "nominativo",
          sortable: false,
        },
        {
          text: "Data firma",
          value: "date_firma",
          sortable: false,
        },
        {
          text: "Cod. Alternativo",
          value: "cod_alternativo",
          sortable: false,
        },
        {
          text: "Revisione",
          value: "revisione_articolo",
          sortable: false,
        },
        {
          text: "Indice",
          value: "indice_modifica",
          sortable: false,
        },
        {
          text: "D.U.M",
          value: "_dum",
          sortable: false,
        },
        {
          text: "Allegati",
          value: "disegno",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
      ],
      items_scadenza: new Array(),
    };
  },
  methods: {
    closepdf(){
        this.pdfdialog = false;
    },
    annullaScadenza() {
      this.scadenza = null;
      this.$emit("update_scadenza", null);
    },
    annullaUMScadenza() {
      this.id_um_scadenza = null;
      this.$emit("update_um_scadenza", null);
    },
    async save() {
      let req_data = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticologestionelotti",
          token: localStorage.user_token,
          articolo: this.itemsLotti,
        },
      };
      await this.$store
        .dispatch("api", req_data)
        .then((res) => {
          this.itemsLotti = res.data.result;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    async getTabelle() {
      let req_data = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "'FORNITURA_STANDARD','TIPO_PREFISSO_LOTTO', 'UNITA_MISURA'",
          filter: "validita = 1",
        },
      };
      await this.$store
        .dispatch("api", req_data)
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              this.forniture =
                res.data.FORNITURA_STANDARD != null
                  ? res.data.FORNITURA_STANDARD
                  : new Array();
              this.items_tipi_lotto =
                res.data.TIPO_PREFISSO_LOTTO != null
                  ? res.data.TIPO_PREFISSO_LOTTO
                  : new Array();

              // Registro le unità di misura delle scadenze.
              this.items_scadenza =
                res.data.UNITA_MISURA != null
                  ? res.data.UNITA_MISURA.filter(
                      (um) =>
                        um.val_txt == "H" &&
                        (um.cod == "GG" || um.cod == "MM" || um.cod == "YY")
                    )
                  : new Array();
              return true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non è stato possibile caricare i dati."
              );
              return false;
            }
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    async getLotti() {
      let req_data = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticologestionelotti",
          token: localStorage.user_token,
          id_articolo: this.data.id_articolo,
        },
      };
      await this.$store.dispatch("api", req_data).then((res) => {
        this.itemsLotti = res.data.result;
        for (const f of this.forniture) {
          if (
            this.itemsLotti.filter((e) => e.id_tabella == f.id_tabella)
              .length == 0
          ) {
            this.itemsLotti.push({
              id_articolo_gestione_lotti: -1,
              id_tabella: f.id_tabella,
              id_articolo: this.data.id_articolo,
              formato_codice_lotto: "",
              validita: 1,
            });
          }
        }
        for (var l of this.itemsLotti) {
          if (
            this.forniture.filter((e) => e.id_tabella == l.id_tabella).length ==
            0
          ) {
            l.validita = 0;
          }
        }
      });
    },
    openDxf(item) {
      const url = item;
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "dxffile.dxf", { type: "" });
          this.dxfurl = URL.createObjectURL(file);
        });
      this.dxfDialog = true;
    },
    // To resize Images
    resizeImage(img, id) {
      if (img) return;

      if (img.width >= img.height && img.width > 100) {
        let width_nuova = 100;
        // Proporzione -> width_nuova : width = height_nuova : height
        let height_nuova = (width_nuova * img.height) / img.width;

        document.getElementById(id).style.width = width_nuova + "px";
        document.getElementById(id).style.height = height_nuova + "px";
      } else if (img.height > img.width && img.height > 100) {
        let height_nuova = 100;
        // Proporzione -> width_nuova : width = height_nuova : height
        let width_nuova = (height_nuova * img.width) / img.height;
        document.getElementById(id).style.width = width_nuova + "px";
        document.getElementById(id).style.height = height_nuova + "px";
      } else {
        document.getElementById(id).style.width = img.width + "px";
        document.getElementById(id).style.height = img.height + "px";
      }
    },
    // PDF MOdal
    isPdf(elem) {
      if (elem) {
        if (elem.startsWith("data:application/pdf")) {
          return true;
        } else {
          return false;
        }
      }
    },
    isDxF(elem) {
      if (elem) {
        if (elem.startsWith("data:application/octet-stream")) {
          return true;
        } else {
          return false;
        }
      }
    },
    openPdfAppenaCaricato(item) {
      if (item.startsWith("data:application/pdf")) {
        const byteCharacters = atob(item.substring(28));
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        this.selectedPdf = blobUrl;
        this.pdfdialog = true;
      }
    },
    openPdf(item) {
      const byteCharacters = atob(item.disegno.substring(28));
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      this.selectedPdf = blobUrl;
      this.pdfdialog = true;
    },
    // Del Selected Item
    delSelectedItem() {
      this.deletedDisegno = {};
      this.dialogElimina = false;
    },
    // Delete Confirmation Dialog
    disegnoToDel(item) {
      this.dialogElimina = true;
      this.deletedDisegno = item;
    },
    // In order to sign disegno
    signdrawing() {
      this.overlay = true;
      let req = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setfirmadisegno",
          token: localStorage.user_token,
          id_disegno: this.selectedDisegno,
        },
      };
      this.$store.dispatch("api", req).then(() => {
        this.$refs.SnackbarQV.print(
          "success",
          "Modifica effettuata con successo!"
        );

        this.caricaDisegni();
      });
      this.overlay = false;
      this.dialogFirma = false;
    },
    // open firma disegno modal
    signatureDisegno(item) {
      this.dialogFirma = true;
      this.selectedDisegno = item.id_disegno;
    },
    clearImage() {
      this.dialogAllegati = false;
    },
    retrieveImageFromClipboardAsBase64(pasteEvent, callback, imageFormat) {
      if (pasteEvent.clipboardData == false) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      var items = pasteEvent.clipboardData.items;
      if (items == undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      for (var i = 0; i < items.length; i++) {
        // Skip content if not image
        if (items[i].type.indexOf("image") == -1) continue;
        // Retrieve image on clipboard as blob
        var blob = items[i].getAsFile();
        // Create an abstract canvas and get context
        var mycanvas = document.createElement("canvas");
        var ctx = mycanvas.getContext("2d");
        // Create an image
        var img = new Image();
        // Once the image loads, render the img on the canvas
        img.onload = function () {
          // Update dimensions of the canvas with the dimensions of the image
          mycanvas.width = this.width;
          mycanvas.height = this.height;
          // Draw the image
          ctx.drawImage(img, 0, 0);
          // Execute callback with the base64 URI of the image
          if (typeof callback == "function") {
            callback(mycanvas.toDataURL(imageFormat || "image/png"));
          }
        };
        // Crossbrowser support for URL
        var URLObj = window.URL || window.webkitURL;
        // Creates a DOMString containing a URL representing the object given in the parameter
        // namely the original Blob
        img.src = URLObj.createObjectURL(blob);
      }
    },
    onPaste(e) {
      if (e.clipboardData != false) {
        var items = e.clipboardData.items;
        if (items != undefined) {
          for (var i = 0; i < items.length; i++) {
            // Skip content if not image
            if (items[i].type.indexOf("image") == -1) continue;
            // Retrieve image on clipboard as blob
            var blob = items[i].getAsFile();
            console.log(blob);
          }
        }
      }
      let that = this;
      this.retrieveImageFromClipboardAsBase64(e, function (imageDataBase64) {
        that.disegno = imageDataBase64;
      });
    },
    hasExtension(file, exts) {
      return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
        file.name
      );
    },
    onFileChange(val) {
      if (
        this.hasExtension(val, [
          ".gif",
          ".jpeg",
          ".JPEG",
          ".jpg",
          ".JPG",
          ".pdf",
          ".png",
          ".PNG",
          ".dxf",
        ])
      ) {
        let that = this;
        let reader = new FileReader();

        reader.onload = function () {
          if (that.hasExtension(val, [".pdf"])) {
            /* Se il file è un PDF lo registro senza eseguire la logica
             * per cambiare le dimensioni del css per la miniatura. */
            that.disegno = reader.result;
          } else {
            /* Se invece è un'immagine, creo una Image e la
             * uso per adattare le dimensioni alla miniatura.*/
            let image = new Image();

            image.onload = function () {
              let width, height;
              let ratio = image.width / image.height;
              if (image.width > image.height) {
                width = Math.min(500, image.width);
                height = width / ratio;
              } else {
                height = Math.min(500, image.height);
                width = height * ratio;
              }

              let canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(image, 0, 0, width, height);

              that.disegno = ctx.canvas.toDataURL();
              that.resizeImage(image, "immagine");
            };

            image.src = reader.result;
            that.disegno = reader.result;
          }
        };

        reader.onerror = function (error) {
          console.error(error);
        };

        reader.readAsDataURL(val);
      } else {
        this.dialogAllegati = false;
        this.$refs.SnackbarQV.print("orange", "Tipo di file non accettato.");
      }
      this.dialogAllegati = false;
    },
    // Setting value to show in edit form of Disegno
    handleclick(item) {
      this.dialog = true;
      this.specifiche_sel = new Specifiche(item);
      moment(this.specifiche_sel.dum, "DD/MM/YYYY").format("YYYY-MM-DD");
      this.disegno = this.specifiche_sel.disegno;
      let that = this;
      var image = new Image();
      image.src = this.disegno;

      image.onload = function () {
        that.resizeImage(image, "immagine");
      };
    },
    // when closing modal setting form values to empty
    closeModal() {
      this.specifiche_sel = new Specifiche();
      this.dialog = false;
    },
    //In order to Delete single disegno
    deldisegno() {
      this.overlay = true;
      let data = {};
      data.id_disegno = this.deletedDisegno.id_disegno;
      data.validita = 0;
      let dataArray = [data];
      let delreq = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticolodisegno",
          id_articolo: this.data.id_articolo,
          articolo_disegni: dataArray,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api", delreq).then((res) => {
        this.overlay = false;
        if (res.data) {
          this.$refs.SnackbarQV.print(
            "success",
            "Modifica effettuata con successo!"
          );
        }
      });
      const i = this.items.findIndex((it) => it.id_disegno === data.id_disegno);
      this.items.splice(i, 1);
      this.dialogElimina = false;
    },
    // In order to save or update disegno
    slavaDesigno() {
      if (this.specifiche_sel.id_disegno == -1) {
        if (this.specifiche_sel.cod_alternativo === "") {
          this.$refs.SnackbarQV.print(
            "orange",
            "Valorizzare il Cod. Alternativo prima di salvare."
          );
          return;
        }
        if (this.specifiche_sel.indice_modifica === "") {
          this.$refs.SnackbarQV.print(
            "orange",
            "Valorizzare il l'Indice di modifica prima di salvare."
          );
          return;
        }
        if (this.specifiche_sel.dum === "") {
          this.$refs.SnackbarQV.print(
            "orange",
            "Valorizzare la Data di Ultima Modifica prima di salvare."
          );
          return;
        }
        if (this.disegno === "") {
          this.$refs.SnackbarQV.print(
            "orange",
            "Selezionare un allegato prima di salvare."
          );
          return;
        }

        const data = new Specifiche(this.specifiche_sel);
        data.id_articolo = this.data.id_articolo;
        data.disegno = this.disegno;
        let dataArray = [];
        dataArray.push(data);
        this.overlay = true;
        let saveDesigno = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setarticolodisegno",
            token: localStorage.getItem("user_token"),
            id_articolo: this.data.id_articolo,
            articolo_disegni: dataArray,
          },
        };
        this.$store.dispatch("api", saveDesigno).then(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "success",
            "Modifica effettuata con successo!"
          );

          this.caricaDisegni();
        });
        this.dialog = false;
      }
      if (this.specifiche_sel.id_disegno > -1) {
        const data = new Specifiche(this.specifiche_sel);
        data.id_articolo = this.data.id_articolo;
        data.disegno = this.disegno;
        let dataArray = [];
        dataArray.push(data);
        let saveDesigno = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setarticolodisegno",
            token: localStorage.getItem("user_token"),
            id_articolo: this.data.id_articolo,
            articolo_disegni: dataArray,
          },
        };
        this.$store.dispatch("api", saveDesigno).then(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "success",
            "Modifica effettuata con successo!"
          );

          this.caricaDisegni();
        });
        //  this.caricaDisegni();
        const i = this.items.findIndex(
          (it) => it.id_disegno === data.id_disegno
        );
        this.items.splice(i, 1, data);
        this.dialog = false;
        this.specifiche_sel = new Specifiche();
      }
    },
    // In order to get list of Disegni to populate the table
    caricaDisegni() {
      this.progressBar = true;
      this.loading = true;
      let disegnoReq = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolidisegno",
          token: localStorage.getItem("user_token"),
          id_articolo: this.data.id_articolo,
        },
      };
      this.$store.dispatch("api", disegnoReq).then((res) => {
        this.progressBar = false;
        this.loading = false;
        this.items = res.data;
      });
    },
    getReports() {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getreport",
          token: localStorage.getItem("user_token"),
        },
      };

      this.loading = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.items_report = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.loading = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
  },
  computed: {
    dum_format() {
      return this.specifiche_sel.dum
        ? moment(this.specifiche_sel.dum, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "";
    },
  },
  async mounted() {
    this.caricaDisegni();
    await this.getTabelle();
    this.getLotti();
    this.getReports();
    this.id_report = this.data?.id_report;
    this.scadenza = this.data?.scadenza;
    this.id_um_scadenza = this.data?.id_um_scadenza;
    this.prelievo_lotti_successivi = this.data?.prelievo_lotti_successivi;
    this.prefisso_lotto = this.data?.prefisso_lotto;
    this.cod_prefisso_lotto = this.data?.cod_prefisso_lotto;
    this.barcode = this.data?.barcode;
  },
  watch: {
    id_report: {
      immediate: true,
      handler() {
        if (this.id_report != null && this.id_report != "") {
          this.$emit("update_id_report", this.id_report);
        }
      },
    },

    scadenza: {
      immediate: true,
      handler() {
        if (this.scadenza != null && this.scadenza != "") {
          this.$emit("update_scadenza", this.scadenza);
        }
      },
    },

    id_um_scadenza: {
      immediate: true,
      handler() {
        if (this.id_um_scadenza != null && this.id_um_scadenza != "") {
          this.$emit("update_um_scadenza", this.id_um_scadenza);
        }
      },
    },

    barcode: {
      immediate: true,
      handler() {
        if (
          this.barcode !== null &&
          this.barcode !== undefined &&
          this.barcode !== ""
        ) {
          this.$emit("update_barcode", this.barcode);
        }
      },
    },

    cod_prefisso_lotto: {
      immediate: true,
      handler() {
        if (
          this.cod_prefisso_lotto !== null &&
          this.cod_prefisso_lotto !== undefined &&
          this.cod_prefisso_lotto !== ""
        ) {
          this.$emit("update_cod_prefisso_lotto", this.cod_prefisso_lotto);
        }
      },
    },
    prefisso_lotto: {
      immediate: true,
      handler() {
        if (
          this.prefisso_lotto !== null &&
          this.prefisso_lotto !== undefined &&
          this.prefisso_lotto !== ""
        ) {
          this.$emit("update_prefisso_lotto", this.prefisso_lotto);
        }
      },
    },
    prelievo_lotti_successivi: {
      immediate: true,
      handler() {
        if (
          this.prelievo_lotti_successivi !== null &&
          this.prelievo_lotti_successivi !== undefined &&
          this.prelievo_lotti_successivi !== ""
        ) {
          this.$emit(
            "update_prelievo_lotti_successivi",
            this.prelievo_lotti_successivi
          );
        }
      },
    },
  },
};
</script>
